/**
 * SoraCart Bundle Progress Bar — Complete Final Version
 * ======================================================
 * - Cart drawer auto-opens on Add to Cart (product page)
 * - Progress bar updates after add-to-cart AND after qty change in drawer
 * - Does NOT intercept or duplicate Horizon's native add-to-cart handling
 * - Watches cart-items-component with subtree:true for hydration-mode patches
 */

(function () {
  'use strict';

  // ================================================================
  //  CONFIGURATION — only edit this block to add/change offers
  // ================================================================

  var BUNDLE_OFFERS = [
    {
      productId:     10292957184243,  // Magic Eraser Sponge — Pack of 4
      requiredQty:   2,
      discountLabel: '5% OFF',
      discountPct:   5,
    },
    {
      productId:     15419784626419,  // Retro Sewing Machine
      requiredQty:   2,
      discountLabel: '10% OFF',
      discountPct:   10,
    },
    // Add more products here:
    // {
    //   productId:     1234567890,
    //   requiredQty:   3,
    //   discountLabel: '15% OFF',
    //   discountPct:   15,
    // },
  ];

  // ================================================================
  //  ICONS
  // ================================================================

  var ICON_LOCK = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<rect x="3" y="6" width="8" height="6" rx="1" stroke="#C96A1E" stroke-width="1.2"/>'
    + '<path d="M5 6V4.5a2 2 0 0 1 4 0V6" stroke="#C96A1E" stroke-width="1.2" stroke-linecap="round"/>'
    + '</svg>';

  var ICON_CHECK = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<circle cx="7" cy="7" r="7" fill="#2A7A4B"/>'
    + '<path d="M3.5 7L6 9.5L10.5 5" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';

  // ================================================================
  //  OFFER LOGIC
  // ================================================================

  function resolveActiveOffer(items) {
    if (!Array.isArray(items) || items.length === 0) return null;

    var evaluated = BUNDLE_OFFERS.map(function (offer) {
      var eligibleQty = items
        .filter(function (item) { return item.product_id === offer.productId; })
        .reduce(function (sum, item) { return sum + item.quantity; }, 0);

      var state = eligibleQty === 0
        ? 'none'
        : eligibleQty >= offer.requiredQty
          ? 'unlocked'
          : 'partial';

      var pct = eligibleQty === 0
        ? 0
        : eligibleQty >= offer.requiredQty
          ? 100
          : Math.round((eligibleQty / offer.requiredQty) * 100);

      var needed = Math.max(0, offer.requiredQty - eligibleQty);

      return { offer: offer, eligibleQty: eligibleQty, pct: pct, state: state, needed: needed };
    }).filter(function (e) { return e.state !== 'none'; });

    if (evaluated.length === 0) return null;

    evaluated.sort(function (a, b) {
      if (a.state === 'unlocked' && b.state !== 'unlocked') return -1;
      if (b.state === 'unlocked' && a.state !== 'unlocked') return  1;
      if (a.state === 'unlocked' && b.state === 'unlocked') {
        return b.offer.discountPct - a.offer.discountPct;
      }
      return a.needed - b.needed;
    });

    return evaluated[0];
  }

  // ================================================================
  //  DOM UPDATE
  //  Re-queries [data-bundle-bar] every time — morphSection replaces
  //  the DOM so old element references become stale
  // ================================================================

  function updateBar(items) {
    var bar = document.querySelector('[data-bundle-bar]');
    if (!bar) return;

    var evaluated = resolveActiveOffer(items);

    if (!evaluated) {
      bar.setAttribute('hidden', '');
      return;
    }

    var offer  = evaluated.offer;
    var pct    = evaluated.pct;
    var state  = evaluated.state;
    var needed = evaluated.needed;

    var heading = state === 'unlocked'
      ? offer.discountLabel + ' Bundle Discount Unlocked!'
      : 'Unlock ' + offer.discountLabel;

    var message = state === 'unlocked'
      ? 'Your eligible packs qualify for ' + offer.discountLabel + '.'
      : 'Add ' + needed + ' more pack' + (needed > 1 ? 's' : '') + ' to unlock your bundle discount.';

    bar.removeAttribute('hidden');
    bar.className = 'sc-bundle-bar sc-bundle-bar--' + state;

    var iconEl    = bar.querySelector('[data-bundle-icon]');
    var headingEl = bar.querySelector('[data-bundle-heading]');
    var messageEl = bar.querySelector('[data-bundle-message]');
    var fillEl    = bar.querySelector('[data-bundle-fill]');
    var trackEl   = bar.querySelector('[role="progressbar"]');

    if (iconEl)    iconEl.innerHTML      = state === 'unlocked' ? ICON_CHECK : ICON_LOCK;
    if (headingEl) headingEl.textContent = heading;
    if (messageEl) messageEl.textContent = message;
    if (fillEl)    fillEl.style.width    = pct + '%';
    if (trackEl) {
      trackEl.setAttribute('aria-valuenow', String(pct));
      trackEl.setAttribute('aria-label', 'Bundle discount progress: ' + pct + '%');
    }
  }

  // ================================================================
  //  FETCH CART
  //  Called AFTER DOM is settled — server cart is already updated
  // ================================================================

  var isFetching   = false;
  var pendingFetch = false;

  function fetchCartAndUpdate() {
    if (isFetching) {
      pendingFetch = true;
      return;
    }
    isFetching   = true;
    pendingFetch = false;

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        updateBar(data.items || []);
      })
      .catch(function (err) {
        console.warn('[SoraCart Bundle Bar] Cart fetch error:', err);
      })
      .finally(function () {
        isFetching = false;
        if (pendingFetch) fetchCartAndUpdate();
      });
  }

  // ================================================================
  //  CART-LINES-UPDATE EVENT LISTENER
  //
  //  Horizon's product-form-component dispatches CartLinesUpdateEvent
  //  with action:'add' when Add to Cart is clicked on the product page.
  //  cart-drawer.js auto-opens the drawer from this same event.
  //  We hook into the event's promise to update the bar AFTER the
  //  cart fetch completes — so bar is ready when drawer slides open.
  // ================================================================

  function initCartLinesUpdateListener() {
    document.addEventListener('cart-lines-update', function (event) {
      // Only care about add actions from the product page
      if (event.action !== 'add') return;

      event.promise
        && event.promise
          .then(function (resolved) {
            var detail = resolved && resolved.detail;

            // Skip failed requests
            if (detail && detail.didError) return;

            // Use items from the event if available (no extra fetch needed)
            if (detail && Array.isArray(detail.items)) {
              updateBar(detail.items);
            } else {
              fetchCartAndUpdate();
            }
          })
          .catch(function (err) {
            if (err && err.name !== 'AbortError') {
              console.warn('[SoraCart Bundle Bar] cart-lines-update error:', err);
            }
          });
    });
  }

  // ================================================================
  //  MUTATION OBSERVER on cart-items-component
  //
  //  Fires after every quantity change in the drawer (morphSection
  //  replaces DOM in hydration mode — deep node patches, not just
  //  direct children).
  //
  //  subtree: true  — catches hydration-mode deep patches
  //  attributes: true — catches hidden/class changes on existing nodes
  //  Self-mutation guard — ignores changes made by our own updateBar()
  //  50ms debounce — batches rapid mutations into one fetch
  // ================================================================

  var debounceTimer = null;

  function debouncedFetch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetchCartAndUpdate();
    }, 50);
  }

  function isBundleBarNode(node, cartComponent) {
    var cursor = node;
    while (cursor && cursor !== cartComponent) {
      if (cursor.hasAttribute && cursor.hasAttribute('data-bundle-bar')) return true;
      cursor = cursor.parentNode;
    }
    return false;
  }

  function observeCartComponent(cartComponent) {
    var observer = new MutationObserver(function (mutations) {
      var relevant = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        // Ignore mutations on the bundle bar itself (our own writes)
        if (isBundleBarNode(m.target, cartComponent)) continue;

        if (m.type === 'childList' && m.addedNodes.length > 0) {
          relevant = true;
          break;
        }
        if (m.type === 'attributes') {
          relevant = true;
          break;
        }
      }

      if (relevant) debouncedFetch();
    });

    observer.observe(cartComponent, {
      childList:       true,
      subtree:         true,   // KEY: catches Horizon's deep hydration-mode patches
      attributes:      true,
      attributeFilter: ['hidden', 'class', 'data-cart-quantity']
    });
  }

  // ================================================================
  //  BODY WATCHER
  //  cart-items-component[data-drawer] doesn't exist when cart is
  //  empty. Watch for it to appear when first item is added.
  // ================================================================

  var bodyObserver = null;

  function watchCartItemsComponent() {
    var cartComponent = document.querySelector('cart-items-component[data-drawer]');

    if (cartComponent) {
      observeCartComponent(cartComponent);
      return;
    }

    bodyObserver = new MutationObserver(function () {
      var found = document.querySelector('cart-items-component[data-drawer]');
      if (found) {
        if (bodyObserver) {
          bodyObserver.disconnect();
          bodyObserver = null;
        }
        observeCartComponent(found);
        fetchCartAndUpdate();
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ================================================================
  //  SECTION RELOAD (theme editor / Section Rendering API)
  // ================================================================

  document.addEventListener('shopify:section:load', function () {
    fetchCartAndUpdate();
    watchCartItemsComponent();
  });

  // ================================================================
  //  INIT
  // ================================================================

  function init() {
    fetchCartAndUpdate();           // Correct state on page load
    watchCartItemsComponent();      // Watch qty changes in drawer
    initCartLinesUpdateListener();  // Watch add-to-cart from product page
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
